<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            :editable="editable"
            label="팀명(반)"
            name="deptCd"
            :isFirstValue="false"
            v-model="searchParam.deptCd"
          >
          </c-dept>
        </div>
      </template>
    </c-search-box>
    <!-- 유해위험요인 목록 -->
    <c-table
      ref="table"
      title="안전보건 위험정보 목록"
      tableId="riskHazrd01"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :selection="popupParam.type"
      rowKey="riskProcessCd"
      @rowDblclick="rowDblclick"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            label="LBLSELECT"
            icon="add"
            @btnClicked="select"
          />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "risk-hazard",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        type: "single",
        deptCd: "",
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return "auto";
      },
    },
  },
  data() {
    return {
      searchParam: {
        useFlag: "Y",
        deptCd: "",
      },
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: "deptName",
            field: "deptName",
            label: "팀명(반)",
            align: "center",
            style: "width: 130px",
            sortable: false,
          },
          {
            name: "processName",
            field: "processName",
            label: "공정",
            type: "link",
            align: "left",
            style: "width: 200px",
            sortable: false,
          },
          {
            name: "mainMaterial",
            field: "mainMaterial",
            label: "원(재)료",
            style: "width: 100px",
            align: "left",
            sortable: false,
          },
          {
            name: "workerCnt",
            field: "workerCnt",
            label: "근로자수",
            style: "width: 80px",
            align: "right",
            sortable: false,
          },
          {
            name: "productName",
            field: "productName",
            label: "생산품기종",
            style: "width: 100px",
            align: "left",
            sortable: false,
          },
        ],
        data: [],
        height: "500px",
      },
      editable: true,
      listUrl: "",
    };
  },
  watch: {
    contentHeight() {
      this.grid.height = this.contentHeight - 100 + "px";
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.riskProcess.list.url;

      if (this.popupParam.deptCd) {
        this.searchParam.deptCd = this.popupParam.deptCd;
      }
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    select() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        this.$emit("closePopup", selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === "single") {
        this.$emit("closePopup", [row]);
      }
    },
    linkClick(row) {
      this.popupOptions.title = "안전보건 위험정보 상세";
      this.popupOptions.param = { riskProcessCd: row ? row.riskProcessCd : ''};
      this.popupOptions.target = () => import(`${"./riskProcessManageDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.width = '80%';
      this.popupOptions.isFull = false;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  },
};
</script>
